import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { ServicioComplementario } from "app/main/apps/shared/models/servicio-complementario.model";

@Component({
    selector: "app-servicios-complementarios",
    templateUrl: "./servicios-complementarios.component.html",
    styleUrls: ["./servicios-complementarios.component.scss"],
})
export class ServiciosComplementariosComponent implements OnInit {
    @Input() serviciosComplementarios: {
        servicios: ServicioComplementario[];
        archivos: File[];
    };
    @Output() quitarServicio: EventEmitter<number> = new EventEmitter();
    @Output()
    editarServicio: EventEmitter<any> = new EventEmitter();
    @Output() agregarServicio: EventEmitter<any> = new EventEmitter();
    constructor() {}

    ngOnInit(): void {}

    editar(servicio: ServicioComplementario, idx: number) {
        //console.log(this.serviciosComplementarios);
        const data = {
            servicioComplementario: servicio,
            archivo: this.serviciosComplementarios.archivos[idx],
            editar: true,
            idx,
        };
        this.editarServicio.emit(data);
    }

    quitar(idx: number) {
        this.quitarServicio.emit(idx);
    }

    agregar() {
        const data = {
            servicioComplementario: null,
            editar: false,
        };
        this.agregarServicio.emit(data);
    }
}
